;
//# sourceMappingURL=my-date-range.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-date-range.interface.js
// module id = 877
// module chunks = 9